export type CommentReply = {
  id: string
  name: string
  initials: string
  avatarColor: string
  avatar?: string
  replyingTo: string
  body: string
  time: string
  likes: number
}

export type Comment = Omit<CommentReply, 'replyingTo'> & {
  replies?: CommentReply[]
}

const AV = 'https://cdn.magicpatterns.com/patterns/generated-images/'

export const comments: Comment[] = [
  {
    id: 'mariana',
    name: 'Mariana López',
    initials: 'ML',
    avatarColor: '#b9676a',
    avatar: `${AV}4d2c3d2b-6373-4438-81ab-244a5ad6fa31.jpg`,
    body: 'Tengo 43 años y me sentí muy identificada con la parte de “como sano pero igual me inflamo”. Durante mucho tiempo mi cena era ensalada, yogur o alguna tostada integral porque pensaba que era lo más liviano. Y sin embargo me acostaba con la panza dura y a la mañana me levantaba peor. Nunca se me había ocurrido pensar que el problema podía ser el horario o la forma de preparar la comida, no solo el alimento en sí.',
    time: '8 min',
    likes: 64,
  },
  {
    id: 'claudia',
    name: 'Claudia Fernández',
    initials: 'CF',
    avatarColor: '#7a5c8f',
    body: 'Esto me hizo muchísimo sentido. Siempre pensé que si algo era saludable, tenía que servirme en cualquier momento del día. Pero ahora que lo pienso, no me cae igual una ensalada al mediodía que a la noche. De hecho, varias veces me pasó de cenar “bien” y dormir pésimo. Me parece interesante mirar la cena desde ese lugar y no solo desde las calorías.',
    time: '21 min',
    likes: 38,
  },
  {
    id: 'patricia',
    name: 'Patricia Gómez',
    initials: 'PG',
    avatarColor: '#4f7a6a',
    body: 'A mí me pasa exactamente con el yogur de noche. Lo uso como cena cuando estoy cansada o cuando no quiero cocinar, porque siento que es “seguro”. Pero después me despierto con hambre, con gases o con una sensación rara en el estómago. Me cuesta aceptar que algo que una cree liviano pueda no estar ayudando, pero la verdad es que mi cuerpo me lo viene diciendo hace rato.',
    time: '34 min',
    likes: 52,
    replies: [
      {
        id: 'laura',
        name: 'Laura Méndez',
        initials: 'LM',
        avatarColor: '#a0694a',
        avatar: `${AV}67938a5a-2b7a-485a-b1ca-f0b2f498dc65.jpg`,
        replyingTo: 'Patricia Gómez',
        body: 'Patricia, me pasa igual. Yo también era de cenar yogur o fruta para no “comer pesado”, y muchas noches terminaba despertándome a las 3 o 4 de la mañana. Empecé a probar cenas calientes y simples, tipo verduras cocidas con algo de proteína, y por lo menos siento el estómago más tranquilo. No digo que sea magia, pero hay una diferencia.',
        time: '19 min',
        likes: 27,
      },
    ],
  },
  {
    id: 'veronica',
    name: 'Verónica Salinas',
    initials: 'VS',
    avatarColor: '#8a5a5a',
    avatar: `${AV}bb849c30-1310-473b-87a7-6789da412ce0.jpg`,
    body: 'Tengo 39 años y desde hace un tiempo siento que mi cuerpo cambió mucho. Antes podía comer cualquier cosa a la noche y al otro día estaba normal. Ahora no. Puedo comer poco, incluso algo que se supone sano, y despertarme inflamada igual. Lo que más me pegó de la nota fue eso de que el cuerpo no está fallando, sino respondiendo a otras reglas. Porque una se culpa muchísimo.',
    time: '52 min',
    likes: 71,
  },
  {
    id: 'gabriela',
    name: 'Gabriela Herrera',
    initials: 'GH',
    avatarColor: '#5b6f8f',
    body: 'Me gustó que la nota no demoniza alimentos. Estoy cansada de leer que todo es malo: que la fruta, que el pan, que los lácteos, que las verduras. Acá entendí otra cosa: que quizás el contexto importa. La hora, la temperatura, la cocción, cómo está una de estresada, cómo duerme. Me pareció una mirada más realista.',
    time: '1 hora',
    likes: 45,
  },
  {
    id: 'silvina',
    name: 'Silvina Ramos',
    initials: 'SR',
    avatarColor: '#9a6b3f',
    avatar: `${AV}513dde37-5ff1-4e00-ba4a-0f9ecd98a740.jpg`,
    body: 'Yo siempre pensé que mi hinchazón era por falta de voluntad o porque “algo hacía mal”. Pero si soy sincera, mi cena muchas veces es lo primero que encuentro: una ensalada fría, un pedazo de pan, queso, yogur, cualquier cosa rápida. Llego agotada y quiero resolver. Después me enojo con mi cuerpo porque amanezco pesada. Capaz el problema no es que no me cuide, sino que me estoy cuidando mal a la noche.',
    time: '1 hora',
    likes: 89,
    replies: [
      {
        id: 'andrea',
        name: 'Andrea Molina',
        initials: 'AM',
        avatarColor: '#6d7a4f',
        replyingTo: 'Silvina Ramos',
        body: 'Silvina, me sentí igual leyendo tu comentario. Creo que muchas confundimos “cenar liviano” con “comer cualquier cosa fría y poca”. A mí me quedó dando vueltas esa frase de que la cena debería ayudar al cuerpo a descansar, no hacerlo trabajar más.',
        time: '48 min',
        likes: 33,
      },
    ],
  },
  {
    id: 'natalia',
    name: 'Natalia Suárez',
    initials: 'NS',
    avatarColor: '#b0577a',
    body: 'Lo que más valoro es que por fin alguien lo baja a algo concreto. Se habla mucho de microbiota, probióticos, flora intestinal, enzimas, inflamación… pero una termina el video o el artículo y piensa: “Bueno, ¿y hoy a la noche qué como?”. Para mí ahí está el problema. Necesito una guía práctica, porque a las 9 de la noche no tengo cabeza para investigar ni inventar recetas.',
    time: '2 horas',
    likes: 58,
  },
  {
    id: 'marcela',
    name: 'Marcela Benítez',
    initials: 'MB',
    avatarColor: '#6a5a8a',
    avatar: `${AV}5bd003d7-7bff-41e7-84c8-ea5f3f22651c.jpg`,
    body: 'Tengo 47 y llevo años con distensión abdominal. Me hice estudios, probé dejar harinas, probé comer menos, probé ayunos, probé infusiones. Algunas cosas ayudan un tiempo, pero después vuelvo a lo mismo. Leyendo esto me di cuenta de que casi nunca miré la cena como un momento específico. Siempre pensaba en “mi alimentación” en general, pero no en lo que le doy al cuerpo justo antes de dormir.',
    time: '2 horas',
    likes: 42,
  },
  {
    id: 'rocio',
    name: 'Rocío Martínez',
    initials: 'RM',
    avatarColor: '#3f7a7a',
    avatar: `${AV}d626c80d-ede0-46a0-9b44-53ccedcbaa9b.jpg`,
    body: 'Me pasó algo muy puntual: cuando ceno algo caliente y simple, duermo distinto. No siempre lo hago porque llego cansada, pero cuando lo hago noto menos pesadez. En cambio, cuando ceno picoteo frío o ensalada, termino con ruido en la panza y me despierto incómoda. No sabía cómo explicarlo, pero esta nota le puso palabras.',
    time: '3 horas',
    likes: 36,
  },
  {
    id: 'adriana',
    name: 'Adriana Castillo',
    initials: 'AC',
    avatarColor: '#8f6a4a',
    body: 'Tengo 51 años y lo que más me cansaba era que me dijeran “comé menos”. Si como menos, muchas veces me da más ansiedad o me despierto con hambre. Entonces entrás en un círculo horrible: comés poco, dormís mal, te levantás cansada, al otro día tenés más antojos. Me gustó esta idea de que la cena no tiene que ser castigo, sino algo que el cuerpo pueda procesar mejor.',
    time: '3 horas',
    likes: 61,
  },
  {
    id: 'carolina',
    name: 'Carolina Vázquez',
    initials: 'CV',
    avatarColor: '#a05a6a',
    avatar: `${AV}5238d60e-2bef-485c-a7cb-24d88eab7259.jpg`,
    body: 'Lo de la ensalada me dolió un poco porque era mi cena de cabecera. Lechuga no, pero sí pepino, tomate, zanahoria cruda, brócoli a veces, todo frío. Y sí, muchas noches sentía la panza como inflada de aire. Pensaba que era normal, o que era por la edad. Ahora quiero probar unos días con cenas cocidas a ver qué pasa.',
    time: '4 horas',
    likes: 29,
  },
  {
    id: 'monica',
    name: 'Mónica Pereira',
    initials: 'MP',
    avatarColor: '#5a7a5a',
    avatar: `${AV}8e85d4d5-a716-48e1-9f1d-a3f2c1bebe17.jpg`,
    body: 'Me parece importante lo que dice sobre no depender solo de probióticos. Yo compré varios, tomé durante meses y no noté gran cambio. Capaz porque seguía cenando mal, durmiendo poco y comiendo apurada. A veces buscamos una cápsula para arreglar algo que en realidad estamos repitiendo todos los días con hábitos.',
    time: '5 horas',
    likes: 47,
  },
  {
    id: 'alejandra',
    name: 'Alejandra Núñez',
    initials: 'AN',
    avatarColor: '#7a4f6a',
    body: 'Este artículo me agarró justo en un momento en el que estoy frustrada. Tengo 40, camino todos los días, no tomo gaseosa, casi no como dulces, y aun así la panza se me infla muchísimo por la noche. Me da vergüenza incluso ponerme cierta ropa. Lo que más necesito ahora no es otra teoría, sino algo práctico para saber qué cenar sin quedarme con hambre ni cocinar una hora.',
    time: '6 horas',
    likes: 53,
  },
  {
    id: 'paula',
    name: 'Paula Rivero',
    initials: 'PR',
    avatarColor: '#4f6a8a',
    body: 'Lo más real de todo es llegar cansada y terminar comiendo lo que parece más fácil. No es que una no quiera cuidarse. Es que después de trabajar, hijos, casa y mil cosas, no hay energía mental. Por eso me interesa mucho si el método realmente tiene cenas de 15 minutos, porque para mí esa es la diferencia entre hacerlo o abandonarlo.',
    time: '7 horas',
    likes: 40,
  },
  {
    id: 'elena',
    name: 'Elena Torres',
    initials: 'ET',
    avatarColor: '#9a5a4a',
    body: 'Nunca había pensado en la cena como “la última señal metabólica del día”. Esa frase me quedó grabada. Tiene sentido: si lo último que hago antes de dormir es darle al cuerpo algo difícil de digerir, quizás no puedo esperar levantarme liviana y descansada. Me gustó mucho la nota.',
    time: '9 horas',
    likes: 34,
  },
]
